module.exports = __webpack_public_path__ + "static/media/lmg_login.e8f657df.png";